export type NewsForgeErrorState = {
	target_url: boolean;
	category: boolean;
	original_content_title_limit: boolean;
	translated_content_title_limit: boolean;
	translated_content_title: boolean;
};

export const stripHtmlAndJoin = (htmlString: string | null): string => {
	if (!htmlString) return '';

	const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(htmlString);

	if (!hasHtmlTags) {
		return htmlString;
	}

	const temp = document.createElement('div');
	temp.innerHTML = htmlString;
	const paragraphs = Array.from(temp.getElementsByTagName('p'));

	return paragraphs.map((p) => p.textContent || '').join('\n\n');
};

export const joinTextAsHtmlParagraphs = (text: string): string => {
	const paragraphs = text.split(/\n\s*\n/).filter((p) => p.trim() !== '');
	return paragraphs.map((p) => `<p>${p.trim()}</p>`).join('');
};

export const countWords = (text: string): number =>
	text
		.trim()
		.split(/\s+/)
		.filter((word) => word.length > 0).length;

export const autoResizeTextArea = (el: HTMLTextAreaElement | null) => {
	if (!el) return;
	el.style.height = 'auto';
	el.style.height = `${el.scrollHeight}px`;
};
